import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ArrowLeft } from 'lucide-react';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/" className="text-slate-500 hover:text-slate-700 transition-colors">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex items-center gap-2">
            <FileText className="w-6 h-6 text-emerald-600" />
            <span className="font-semibold text-slate-800">CurrículoPRO</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-slate-800 mb-8">Termos de Uso</h1>
        
        <div className="prose prose-slate max-w-none space-y-6">
          <p className="text-slate-600">
            <strong>Última atualização:</strong> {new Date().toLocaleDateString('pt-BR')}
          </p>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">1. Aceitação dos Termos</h2>
            <p className="text-slate-600">
              Ao acessar e usar o CurrículoPRO, você concorda em cumprir e estar vinculado a estes Termos de Uso. 
              Se você não concordar com qualquer parte destes termos, não poderá acessar o serviço.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">2. Descrição do Serviço</h2>
            <p className="text-slate-600">
              O CurrículoPRO é uma ferramenta gratuita online para criação de currículos profissionais. 
              O serviço permite que você:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2">
              <li>Crie currículos profissionais de forma simples e rápida</li>
              <li>Visualize o currículo em tempo real enquanto edita</li>
              <li>Baixe seu currículo em formato PDF</li>
              <li>Salve seus dados localmente no navegador para uso futuro</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">3. Uso Permitido</h2>
            <p className="text-slate-600">
              Você concorda em usar o CurrículoPRO apenas para fins legais e de acordo com estes Termos. 
              Você concorda em não:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2">
              <li>Usar o serviço para qualquer finalidade ilegal ou não autorizada</li>
              <li>Tentar obter acesso não autorizado a qualquer parte do serviço</li>
              <li>Interferir ou interromper o funcionamento do serviço</li>
              <li>Criar currículos com informações falsas para fins fraudulentos</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">4. Propriedade Intelectual</h2>
            <p className="text-slate-600">
              O CurrículoPRO e todo o seu conteúdo, recursos e funcionalidades são de propriedade do 
              criador e estão protegidos por leis de direitos autorais. Você mantém todos os direitos 
              sobre o conteúdo que você cria usando nosso serviço (seu currículo).
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">5. Isenção de Garantias</h2>
            <p className="text-slate-600">
              O serviço é fornecido "como está" e "conforme disponível", sem garantias de qualquer tipo, 
              expressas ou implícitas. Não garantimos que:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2">
              <li>O serviço atenderá às suas necessidades específicas</li>
              <li>O serviço será ininterrupto, seguro ou livre de erros</li>
              <li>Os resultados obtidos pelo uso do serviço serão precisos ou confiáveis</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">6. Limitação de Responsabilidade</h2>
            <p className="text-slate-600">
              Em nenhuma circunstância seremos responsáveis por quaisquer danos indiretos, incidentais, 
              especiais, consequenciais ou punitivos, incluindo, sem limitação, perda de lucros, dados, 
              uso, boa vontade ou outras perdas intangíveis, resultantes do seu acesso ou uso do serviço.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">7. Armazenamento de Dados</h2>
            <p className="text-slate-600">
              Todos os dados do seu currículo são armazenados localmente no seu navegador usando localStorage. 
              Não somos responsáveis pela perda de dados caso você limpe os dados do navegador ou use um 
              dispositivo diferente. Recomendamos que você baixe o PDF do seu currículo para ter uma cópia segura.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">8. Publicidade</h2>
            <p className="text-slate-600">
              O CurrículoPRO exibe anúncios através do Google AdSense para manter o serviço gratuito. 
              Ao usar o serviço, você concorda com a exibição de anúncios conforme descrito em nossa 
              Política de Privacidade.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">9. Modificações nos Termos</h2>
            <p className="text-slate-600">
              Reservamo-nos o direito de modificar ou substituir estes Termos a qualquer momento. 
              É sua responsabilidade verificar periodicamente se há alterações. O uso contínuo do 
              serviço após a publicação de quaisquer modificações constitui aceitação dessas alterações.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">10. Lei Aplicável</h2>
            <p className="text-slate-600">
              Estes Termos serão regidos e interpretados de acordo com as leis do Brasil, 
              sem considerar suas disposições sobre conflitos de leis.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-800">11. Contato</h2>
            <p className="text-slate-600">
              Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco através 
              do canal{' '}
              <a 
                href="https://www.youtube.com/@godgamestutorial" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-emerald-600 hover:underline"
              >
                God Games Tutorial
              </a>.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-800 text-slate-400 py-6 px-4 mt-12">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm">
            Criado por{' '}
            <a
              href="https://www.youtube.com/@godgamestutorial"
              target="_blank"
              rel="noopener noreferrer"
              className="text-emerald-400 hover:text-emerald-300 transition-colors"
            >
              God Games Tutorial
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfUse;
